import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isEmpty} from 'lodash'
import Tooltip from '@material-ui/core/Tooltip';
import {  makeStyles } from '@material-ui/core/styles';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    Tooltip: {
      fontSize:12
    },
  }));

function KundNamn(props) {
    const classes = useStyles();
    const [value, setValue]=React.useState(props.KundNamn)
    const onChangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=(e)=>{
        props.onChangeKund("KundNamn",value)
    }
    return (
        <div>
            <Tooltip title={<IntlMessages id="Customer.Name.required.title"/>} placement="top" classes={classes.Tooltip}>
           <TextField
           error={isEmpty(value)}
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="Customer.Name"/>}
           value={value}
           onChange={onChangeHandle}
           onBlur={onBlurHandle}
           InputLabelProps={{ shrink: true }}
           /> 
           </Tooltip>
        </div>
    );
}

export default KundNamn;